import { telHref } from '../util/tel'

up.compiler('[data-tel-to]', (element: HTMLElement) => {
  element.setAttribute('up-follow', 'false')
  element.setAttribute('href', telHref(element.textContent!))
})
